import { createGenericContext as createStrictContext } from '../scripts/utils';
import { CloudIndex } from './CloudIndex';

const [useCloudIndex, CloudIndexProvider] = createStrictContext<CloudIndex>();
export { useCloudIndex, CloudIndexProvider };
